/* SD — custom elements cho theme bộ 3 (clone seed.com). Không dùng thư viện ngoài. */

/** Rail cuộn ngang: track .sd-rail__track, nút [data-dir="prev"|"next"]. */
class SdRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.sd-rail__track');
    if (!this.track) return;
    this.querySelectorAll('[data-dir]').forEach((btn) => btn.addEventListener('click', () => this.scrollByDir(btn.dataset.dir)));
  }
  scrollByDir(dir) {
    const first = this.track.firstElementChild;
    const step = first ? first.getBoundingClientRect().width + 20 : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
  }
}
customElements.define('sd-rail', SdRail);

/** Card video: bấm play → nhúng YouTube/Vimeo (data-youtube / data-vimeo). */
class SdVideo extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('[data-play]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const { youtube, vimeo, link } = this.dataset;
      if (youtube || vimeo) {
        const frame = document.createElement('iframe');
        frame.src = youtube ? `https://www.youtube.com/embed/${youtube}?autoplay=1&rel=0` : `https://player.vimeo.com/video/${vimeo}?autoplay=1`;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        frame.className = 'sd-video__frame';
        this.querySelector('.sd-video__media').replaceChildren(frame);
        this.querySelectorAll('.sd-video__label').forEach((l) => l.remove());
        btn.remove();
      } else if (link) {
        window.location.href = link;
      }
    });
  }
}
customElements.define('sd-video', SdVideo);

/** Popup email: mở sau `delay` giây nếu chưa đóng (localStorage); [data-close] đóng. Không bật trong Theme Editor. */
class SdPopup extends HTMLElement {
  connectedCallback() {
    if (window.Shopify && window.Shopify.designMode) return;
    const key = 'sdPopupDismissed';
    try { if (localStorage.getItem(key)) return; } catch (e) { /* localStorage bị chặn */ }
    const delay = Number(this.getAttribute('delay') || 4) * 1000;
    this.timer = setTimeout(() => this.classList.add('is-open'), delay);
    const close = () => { this.classList.remove('is-open'); try { localStorage.setItem(key, '1'); } catch (e) { /* bỏ qua */ } };
    this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', close));
    const form = this.querySelector('form');
    if (form) form.addEventListener('submit', () => { try { localStorage.setItem(key, '1'); } catch (e) { /* bỏ qua */ } });
  }
  disconnectedCallback() { clearTimeout(this.timer); }
}
customElements.define('sd-popup', SdPopup);
